import { render, staticRenderFns } from "./permalink.vue?vue&type=template&id=5284b9e5&scoped=true&"
import script from "./permalink.vue?vue&type=script&lang=js&"
export * from "./permalink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5284b9e5",
  null
  
)

export default component.exports